// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3DFmg","emails":"CreateEditClinics_emails__1NcJT","emailTagLabel":"CreateEditClinics_emailTagLabel__3rykP"};